<template>
  <div class="yk-stu-manager-new-wrapper clearfix" style="width:800px;top:100px;">
    <el-form label-width="80px">
      <el-form-item label="标题">
        <el-input v-model="introduceTitle" ></el-input>
      </el-form-item>
      <el-form-item label="介绍：">
        <Editor v-model="introduceContent" placeholder="请输入内容"></Editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="updateAssociation">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      introduceTitle: "",
      introduceContent: "",
      url: "/api/design/osssign/getsign",
      files: [],
      fileList: [],
      urlAliyunOSS: "/api/design/osssign/getsign",
      MedalIconUrl: "",
      AvatorUrl: ""
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  props: {
    certificateId:{
      type:String,
      default: ''
    }
  },
  created() {
    this.getInfo();
  },
  watch: {
    AvatorUrl: function(val) {
      console.log(val);
    }
  },
  methods: {
    getInfo() {
      var that = this;
      this.$http.post("/api/XOrg/Certificate/getCertificateIntroduce", {
        id:this.certificateId
      }).then(function(rst) {
        if (rst.code === 1 && rst.info) {
          that.introduceTitle = rst.info.introduceTitle;
          that.introduceContent = rst.info.introduceContent;
        } else {
          that.$message.warning(rst.msg || "");
        }
      });
    },
    updateAssociation() {
      var that = this;
      this.$http
        .post("/api/XOrg/Certificate/saveCertificateIntroduce", {
          id:this.certificateId,
          introduceTitle: that.introduceTitle,
          introduceContent: that.introduceContent
        })
        .then(function(rst) {
          if (rst.code === 1) {
            that.$message.success(rst.msg);
            that.getInfo();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>